if (!customElements.get('atc-price-label')) {
  customElements.define(
    'atc-price-label',
    class AtcPriceLabel extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.separator = this.dataset.separator || '-';
        this.productInfo = this.closest('product-info');
        this.onQuantityChange = () => this.update();
        this.productInfo?.addEventListener('dd:quantity-change', this.onQuantityChange);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.sectionId) return;
            // Runs after Dawn has finished rewriting the button label.
            requestAnimationFrame(() => this.update());
          });
        }

        this.update();
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        this.productInfo?.removeEventListener('dd:quantity-change', this.onQuantityChange);
      }

      get button() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      getPrice() {
        const pack = this.productInfo?.querySelector('dd-quantity-packs input[name="quantity"]:checked');
        if (pack) return pack.dataset.packTotal || '';
        const container = document.getElementById(`price-${this.sectionId}`);
        if (!container) return '';

        const node = container.querySelector(
          '.pi-price__current, .price__sale .price-item--sale, .price-item--regular'
        );
        return node ? node.textContent.trim() : '';
      }

      update() {
        const button = this.button;
        if (!button || button.hasAttribute('disabled')) return;

        const label = button.querySelector('span');
        const price = this.getPrice();
        if (!label || !price) return;

        const base = (window.variantStrings && window.variantStrings.addToCart) || label.textContent.trim();
        label.textContent = `${base} ${this.separator} ${price}`;
      }
    }
  );
}
